import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  Dropdown,
  message,
  Modal,
  Popconfirm,
  Skeleton,
  Table,
  Tag,
} from "antd";
import { GoPlusCircle } from "react-icons/go";
import { Link, useNavigate, useParams } from "react-router-dom";
import { FaPrint } from "react-icons/fa6";
import { CiEdit, CiSquarePlus } from "react-icons/ci";
import {
  IoArrowBackCircleOutline,
  IoDocumentTextOutline,
} from "react-icons/io5";

import moment from "moment";
import { PiHamburger, PiHamburgerThin } from "react-icons/pi";
import {
  MdDeleteOutline,
  MdOutlineCalculate,
  MdOutlineIncompleteCircle,
} from "react-icons/md";
import { IoMdPerson } from "react-icons/io";
import { useMessage } from "../../Components/MessageProvider/MessageProvider";
import axiosInstance from "../../Components/axiosInstance/AxiosInstance";
import numberToWords from "../../Components/NumberToWords/NumberToWords";
import ClearOutlinedIcon from "@mui/icons-material/ClearOutlined";
import { LiaTrainSolid } from "react-icons/lia";
import TextArea from "antd/es/input/TextArea";
import formatNumberWithSpaces from "../../Components/NumberToWords/FormatNumber";

export default function KochaView() {
  let navigate = useNavigate();
  let elementRef = useRef();

  let [loading, setLoading] = useState(false);
  let [izox, setIzox] = useState("");
  let [data, setData] = useState(false);
  let [isModalOpen, setIsModalOpen] = useState(false);
  let { id } = useParams();
  let messageApi = useMessage();

  let getYukXati = async () => {
    try {
      setLoading(true);
      console.log(id);

      let { data } = await axiosInstance.get("/api/chiqim/" + id);

      if (data.success) {
        console.log("data");
        console.log(data);
        setData(data.data[0]);
      }
    } catch (error) {
      if (error?.response?.data?.error) {
        messageApi.open({
          type: "warning",
          content: error?.response?.data?.message,
        });
      } else {
        messageApi.open({
          type: "warning",
          content: error.message,
        });
      }
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  let tasdiqlash = async () => {
    try {
      setLoading(true);
      console.log(id);

      let { data } = await axiosInstance.post("/api/kocha", {
        nakladnoy_id: id,
        comment_kocha: izox,
        confirm: 1,
      });

      if (data.success) {
        console.log("data");
        console.log(data);
        navigate("/kocha");
        setData(data.data[0]);
      }
    } catch (error) {
      if (error?.response?.data?.error) {
        messageApi.open({
          type: "warning",
          content: error?.response?.data?.message,
        });
      } else {
        messageApi.open({
          type: "warning",
          content: error.message,
        });
      }
      console.log(error);
    } finally {
      setIsModalOpen(false);
      setLoading(false);
    }
  };

  useEffect(() => {
    getYukXati();
  }, []);

  let sum = data?.products?.reduce((cal, curr) => {
    return cal + curr.tonna;
  }, 0);

  const confirm = async () => {
    try {
      setLoading(true);
      console.log(id);

      let { data } = await axiosInstance.post("/api/kocha", {
        nakladnoy_id: id,
        comment_kocha: izox,
        confirm: 0,
      });

      if (data.success) {
        console.log("data");
        console.log(data);
        navigate("/kocha");
        setData(data.data[0]);
      }
    } catch (error) {
      if (error?.response?.data?.error) {
        messageApi.open({
          type: "warning",
          content: error?.response?.data?.message,
        });
      } else {
        messageApi.open({
          type: "warning",
          content: error.message,
        });
      }
      console.log(error);
    } finally {
      setIsModalOpen(false);
      setLoading(false);
    }
  };

  const cancel = (e) => {
    console.log(e);
    //   message.error("Click on No");
  };

  const items = [
    {
      key: "1",
      label: (
        <Link
          className=" block w-[100%] flex items-center justify-start gap-1"
          rel="noopener noreferrer"
          to="/kocha"
        >
          <IoDocumentTextOutline className="font-[30px]" /> Yuk xatlari
        </Link>
      ),
    },
    {
      key: "2",
      label: (
        <Link
          className=" block w-[100%] flex items-center justify-start gap-1"
          rel="noopener noreferrer"
          to="/kocha/vagonlar"
        >
          <LiaTrainSolid className="font-[30px]" /> Vagonlar
        </Link>
      ),
    },
    {
      key: "3",
      label: (
        <Link
          className=" block w-[100%] flex items-center justify-start gap-1"
          rel="noopener noreferrer"
          to="/kocha/vagonlar/new"
        >
          <GoPlusCircle className="font-[30px]" /> Vagon
        </Link>
      ),
    },
    {
      key: "6",
      label: (
        <Link
          className=" block w-[100%] flex items-center justify-start gap-1"
          rel="noopener noreferrer"
          to="/"
        >
          <MdOutlineCalculate className="font-[30px]" /> Jami
        </Link>
      ),
    },
  ];

  if (loading) {
    return (
      <div>
        <div className="max-w-[900px] m-auto w-[100%] flex  bg-[#fff] z-10 flex-row  items-center justify-between p-[10px]">
          <Skeleton.Input
            active
            size="small"
            className=" text-[14px] text-[#111827] p-0 m-0 col-span-2 w-[30px] "
          />
          <Dropdown
            menu={{
              items,
            }}
            placement="topRight"
            arrow
          >
            <Dropdown
              menu={{
                items,
              }}
              placement="topRight"
              arrow
            >
              <Button>
                <PiHamburger />
              </Button>
            </Dropdown>
          </Dropdown>
        </div>
        <div
          className="flex flex-col gap-6 max-w-[900px] w-[90%] m-auto"
          style={{
            height: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          {" "}
          <br></br>
          <Skeleton active />
          <br></br>
          <Skeleton active />
          {/* <Skeleton active />{" "} */}
        </div>
      </div>
    );
  }

  return (
    <div className="pb-[100px]">
      <div className="flex items-center justify-between py-4 px-2">
        <Modal
          title={`${data.name}ga yuk berib yuborim!`}
          open={isModalOpen}
          // loading={loading}
          onOk={() => {
            tasdiqlash();
          }}
          onCancel={() => {
            setIsModalOpen(false);
          }}
        >
          <div>
            <label>Izox</label>
            <TextArea
              onChange={(e) => {
                setIzox(e.target.value);
                console.log(e.target.value);
              }}
              cols={20}
              rows={6}
            />
          </div>
        </Modal>
        {!data?.confirm ? (
          <Button
            onClick={() => {
              setIsModalOpen(true);
            }}
            variant="solid"
          >
            Tasdiqlash
          </Button>
        ) : (
          <Popconfirm
            title="O'chirish"
            loading={true}
            description={
              `'${data.name}'` +
              "ga berib yubormagan qilishga ishonchingiz komilmi?"
            }
            onConfirm={() => {
              confirm();
            }}
            onCancel={cancel}
            okText="Yes"
            cancelText="No"
          >
            <Button variant="solid">{data?.confirm_by}</Button>
          </Popconfirm>
        )}

        <Dropdown
          menu={{
            items,
          }}
          placement="topRight"
          arrow
        >
          <Button>
            <PiHamburger />
          </Button>
        </Dropdown>
      </div>
      <div
        className="flex flex-col gap-6"
        style={{
          height: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div
          class="max-w-[900px] w-[100%] font-sans"
          style={{
            paddingBottom: "30px",
          }}
        >
          <h1
            className="text-center mt-1"
            style={{
              textAlign: "center",
              fontSize: "14px",
            }}
          >
            "МИНЕРАЛ МАРКЕТ" MЧЖ СТИР: 310859855
          </h1>
          <h2
            className="text-[16px] text-center "
            style={{
              textAlign: "center",
              fontSize: "14px",
              margin: 0,
              padding: 0,
            }}
          >
            {moment(data.date).format("DD.MM.YYYY")}{" "}
            <span
              style={{
                paddingLeft: "8px",
                paddingRight: "8px",
                fontSize: "14px",
              }}
            >
              ЙУЛ ВАРАКАСИ
            </span>{" "}
            № {data.nakladnoy_id}
          </h2>
          {/* <p
              className="text-[16px] text-center"
              style={{ textAlign: "center" }}
            >
              № {data.nakladnoy_id} сонли
            </p> */}

          <section class="info">
            <p
              className=""
              style={{
                fontSize: "14px",
                margin: "4px",
              }}
            >
              Автомобиль: {data.auto_number}
            </p>
            <p
              className=""
              style={{
                fontSize: "14px",
                margin: "4px",
              }}
            >
              Хайдовчи: {data.driver_name}
            </p>

            <p
              className=""
              style={{
                fontSize: "14px",
                margin: "4px",
              }}
            >
              Олувчи номи:{" "}
              <Link
                className=""
                style={{
                  fontSize: "14px",
                  margin: "4px",
                }}
                to={"/customer/" + data.customer_id}
              >
                {data.name}
              </Link>
            </p>
            <p
              className=""
              style={{
                fontSize: "14px",
                margin: "4px",
              }}
            >
              Manzil: {data.where}
            </p>
            {/* <p
                className=""
                style={{
                  fontSize: "14px",
                  margin: "4px",
                }}
              >
                Санаси: {moment(data.date).format("DD.MM.YYYY")}
              </p> */}
          </section>
          {/* w-[100%] overflow-auto */}
          <div className="w-[100%] overflow-auto">
            <table
              style={{
                borderCollapse: "collapse",
                width: "100%",
              }}
              border="1"
              className="text-[14px] max-w-[900px] w-[100%] shrink-0"
              cellpadding="10"
            >
              <tr>
                <th
                  style={{
                    fontSize: "14px",
                    margin: 0,
                  }}
                  className="text-[14px] text-left text-bold border border-gray-400 px-4 py-2"
                >
                  Юк номи
                </th>
                <th
                  style={{
                    fontSize: "14px",
                    margin: 0,
                  }}
                  className="text-[14px] text-left text-bold border border-gray-400 px-4 py-2"
                >
                  Ўлчов (Tn)
                </th>
                {/* <th
                  style={{
                    fontSize: "14px",
                    margin: 0,
                  }}
                  className="text-[14px] text-left text-bold border border-gray-400 px-4 py-2"
                >
                  Qayerdan
                </th> */}
                <th
                  style={{
                    fontSize: "14px",
                    margin: 0,
                  }}
                  className="text-[14px] text-left text-bold border border-gray-400 px-4 py-2"
                >
                  {" "}
                  sum (1 qop)
                </th>
              </tr>
              {data?.products?.map((el, i) => {
                return (
                  <tr
                    style={{
                      fontSize: "14px",
                      margin: 0,
                    }}
                  >
                    <td
                      style={{
                        fontSize: "14px",
                        margin: 0,
                        padding: 0,
                        paddingLeft: "4px",
                        lineHeight: "14px",
                        padding: "4px",
                      }}
                      className="text-[14px] text-left text-bold border border-gray-400 px-4 py-1"
                    >
                      {i + 1}. {el.name}
                    </td>
                    <td
                      style={{
                        fontSize: "14px",
                        margin: 0,
                        padding: 0,
                        paddingLeft: "4px",
                        lineHeight: "14px",
                        padding: "4px",
                      }}
                      className="text-[14px] text-left text-bold border border-gray-400 px-4 py-1"
                    >
                      {el.tonna} ({(el.tonna * 1000) / 50} qop)
                    </td>

                    <td
                      style={{
                        fontSize: "14px",
                        margin: 0,
                        padding: "4px",
                      }}
                      className="text-[14px] text-left text-bold border border-gray-400 px-4 py-1"
                    >
                      {" "}
                      {formatNumberWithSpaces(el?.price_qop ? el.price_qop : 0)}
                    </td>
                  </tr>
                );
              })}
            </table>
          </div>

          <footer>
            <div
              className="flex items-center justify-between w-[100%]"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "end",
              }}
            >
              {/* <p className="text-[16px] m-0 p-[3px]">
                Жами миқдори: {numberToWords(sum * 1000)} kg
              </p> */}
              <p className="text-[16px] m-0 p-[3px]">
                {(sum * 1000) / 50} дона Qop
              </p>
            </div>
            <div
              className="flex items-center justify-between w-[100%] pt-5"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <div className="text-[14px] ">
                <p className="text-[12px] text-[#b4b4b4] m-0 px-0">
                  {" "}
                  Berdi:{data.given_by?.id}. {data.given_by?.name}{" "}
                  {data.given_by?.phone}
                </p>
                <p className="text-[12px] text-[#b4b4b4] m-0 py-1">
                  Yozdi: {data.written_by}
                </p>
                <p className="text-[12px] text-[#b4b4b4] m-0 p-0">
                  Yozildi:{" "}
                  {moment(data.created_at).format("MMMM Do, YYYY h:mm A")}
                </p>
              </div>
              <p className="text-[12px]  w-[50%]" style={{ width: "50%" }}>
                {data.comment}
              </p>
            </div>
          </footer>
        </div>
      </div>

      {/* printable content hidden*/}
      <div className="hidden">
        <div
          ref={elementRef}
          className="hidden flex flex-col gap-6 h-[20px] overflow"
          style={{
            height: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div
            class="max-w-[900px] w-[100%] font-sans"
            style={{
              paddingBottom: "100px",
            }}
          >
            <h2
              className="text-[16px] text-center "
              style={{
                textAlign: "center",
                fontSize: "14px",
                margin: 0,
                padding: 0,
              }}
            >
              {moment(data.date).format("DD.MM.YYYY")}{" "}
              <span
                style={{
                  paddingLeft: "8px",
                  paddingRight: "8px",
                  fontSize: "14px",
                }}
              >
                ЙУЛ ВАРАКАСИ
              </span>{" "}
              № {data.nakladnoy_id}
            </h2>

            <section class="info">
              <p
                className=""
                style={{
                  fontSize: "14px",
                  margin: "4px",
                }}
              >
                Автомобиль: {data.auto_number}
              </p>
              <p
                className=""
                style={{
                  fontSize: "14px",
                  margin: "4px",
                }}
              >
                Хайдовчи: {data.driver_name}
              </p>

              <p
                className=""
                style={{
                  fontSize: "14px",
                  margin: "4px",
                }}
              >
                Олувчи номи:{" "}
                <Link
                  className=""
                  style={{
                    fontSize: "14px",
                    margin: "4px",
                  }}
                  to={"/customer/" + data.customer_id}
                >
                  {data.name}
                </Link>
              </p>

              <p
                className=""
                style={{
                  fontSize: "14px",
                  margin: "4px",
                }}
              >
                Ишончнома №{" "}
              </p>
            </section>

            <table
              style={{
                borderCollapse: "collapse",
                width: "100%",
              }}
              border="1"
              className="text-[14px]"
              cellpadding="10"
            >
              <tr>
                <th
                  className="text-[14px] text-left text-bold border border-gray-400 px-4 py-2 border border-gray-400 px-4 py-2"
                  style={{
                    fontSize: "14px",
                    margin: 0,
                  }}
                >
                  №
                </th>
                <th
                  style={{
                    fontSize: "14px",
                    margin: 0,
                  }}
                  className="text-[14px] text-left text-bold border border-gray-400 px-4 py-2"
                >
                  Юк номи
                </th>
                <th
                  style={{
                    fontSize: "14px",
                    margin: 0,
                  }}
                  className="text-[14px] text-left text-bold border border-gray-400 px-4 py-2"
                >
                  Ўлчов бирлиги
                </th>
                <th
                  style={{
                    fontSize: "14px",
                    margin: 0,
                  }}
                  className="text-[14px] text-left text-bold border border-gray-400 px-4 py-2"
                >
                  Тара
                </th>
                <th
                  style={{
                    fontSize: "14px",
                    margin: 0,
                  }}
                  className="text-[14px] text-left text-bold border border-gray-400 px-4 py-2"
                >
                  {" "}
                  Умумий огирлик
                </th>
                <th
                  style={{
                    fontSize: "14px",
                    margin: 0,
                  }}
                  className="text-[14px] text-left text-bold border border-gray-400 px-4 py-2"
                >
                  Соф огирлик
                </th>
              </tr>
              {data?.products?.map((el, i) => {
                return (
                  <tr
                    style={{
                      fontSize: "14px",
                      margin: 0,
                    }}
                  >
                    <td
                      style={{
                        fontSize: "14px",
                        margin: 0,
                        padding: "4px",
                      }}
                      className="text-[14px] text-left text-bold border border-gray-400 px-4 py-1"
                    >
                      {i + 1}
                    </td>
                    <td
                      style={{
                        fontSize: "14px",
                        margin: 0,
                        padding: 0,
                        paddingLeft: "4px",
                        lineHeight: "14px",
                        padding: "4px",
                      }}
                      className="text-[14px] text-left text-bold border border-gray-400 px-4 py-1"
                    >
                      {el.name}
                    </td>
                    <td
                      style={{
                        fontSize: "14px",
                        margin: 0,
                        padding: 0,
                        paddingLeft: "4px",
                        lineHeight: "14px",
                        padding: "4px",
                      }}
                      className="text-[14px] text-left text-bold border border-gray-400 px-4 py-1"
                    >
                      Tn
                    </td>
                    <td
                      style={{
                        fontSize: "14px",
                        margin: 0,
                        padding: "4px",
                      }}
                      className="text-[14px] text-left text-bold border border-gray-400 px-4 py-1"
                    ></td>
                    <td
                      style={{
                        fontSize: "14px",
                        margin: 0,
                        padding: "4px",
                      }}
                      className="text-[14px] text-left text-bold border border-gray-400 px-4 py-1"
                    ></td>
                    <td
                      style={{
                        fontSize: "14px",
                        margin: 0,
                        padding: 0,
                        paddingLeft: "4px",
                        lineHeight: "14px",
                        padding: "4px",
                      }}
                      className="text-[14px] text-left text-bold border border-gray-400 px-4 py-1"
                    >
                      {el.tonna}
                    </td>
                  </tr>
                );
              })}
            </table>

            <footer>
              <div
                className="flex items-center justify-between w-[100%]"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <p className="text-[12px] m-0 p-[3px]">
                  Жами миқдори: {numberToWords(sum * 1000)} Kg
                </p>
                <p className="text-[12px] m-0 p-[3px]">
                  {(sum * 1000) / 50} дона Qop
                </p>
              </div>
              <div
                className="flex items-center justify-between w-[100%]"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <p
                  className="text-[12px] "
                  style={{
                    fontSize: "12px",
                    padding: 0,
                    margin: 0,
                  }}
                >
                  Phone: +998 93 894 40 00
                </p>
                <p
                  className="text-[12px] p-0 m-0  w-[50%]"
                  style={{
                    width: "50%",
                    fontSize: "12px",
                    padding: 0,
                    margin: 0,
                  }}
                >
                  Махсулотни ишлаб чиқарувчи томонидан махсус қопларда
                  қадоқанланган холда, сон ва сифати жиҳатдан бутлиги ва
                  тўлиқлигини назоратини қилган тартибда кабул килдим.
                </p>
              </div>
              <div
                className="flex items-center justify-between mt-2"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  marginTop: "4px",
                }}
              >
                <p
                  className="text-[14px] m-0 p-[3px]"
                  style={{
                    fontSize: "12px",
                    padding: 0,
                    margin: 0,
                  }}
                >
                  ______________А.Abduvaliev
                </p>
                <p
                  className="text-[14px] m-0 p-[3px]"
                  style={{
                    fontSize: "12px",
                    padding: 0,
                    margin: 0,
                    marginTop: "8px",
                  }}
                >
                  ______________А.Parpiyev
                </p>
              </div>
            </footer>
          </div>

          <div
            class="max-w-[900px] w-[100%] font-sans"
            style={{
              paddingBottom: "60px",
            }}
          >
            <h1
              className="text-center mt-1"
              style={{
                textAlign: "center",
                fontSize: "14px",
                margin: 0,
                padding: 0,
              }}
            >
              "МИНЕРАЛ МАРКЕТ" MЧЖ СТИР: 310859855
            </h1>
            <h2
              className="text-[16px] text-center "
              style={{
                textAlign: "center",
                fontSize: "14px",
                margin: 0,
                padding: 0,
              }}
            >
              {moment(data.date).format("DD.MM.YYYY")}{" "}
              <span
                style={{
                  paddingLeft: "8px",
                  paddingRight: "8px",
                  fontSize: "14px",
                }}
              >
                ЙУЛ ВАРАКАСИ
              </span>{" "}
              № {data.nakladnoy_id}
            </h2>
            {/* <p
                className="text-[14px] m-0 p-0 pt-1 text-center"
                style={{
                  textAlign: "center",
                  fontSize: "14px",
                  margin: 0,
                  padding: 0,
                }}
              >
                № {data.nakladnoy_id} сонли
              </p> */}

            <section class="info">
              <p
                className=""
                style={{
                  fontSize: "14px",
                  margin: "4px",
                }}
              >
                Автомобиль: {data.auto_number}
              </p>
              <p
                className=""
                style={{
                  fontSize: "14px",
                  margin: "4px",
                }}
              >
                Хайдовчи: {data.driver_name}
              </p>
              <p
                className=" uppercase "
                style={{
                  fontSize: "14px",
                  margin: "4px",
                }}
              >
                <span className=" capitalize text-[14px] ">
                  Етказиб берувчи:
                </span>{" "}
                "{data.branch_name}" MЧЖ СТИР: {data.branch_INN}
              </p>
              <p
                className=""
                style={{
                  fontSize: "14px",
                  margin: "4px",
                }}
              >
                Олувчи номи:{" "}
                <Link
                  className=""
                  style={{
                    fontSize: "14px",
                    margin: "4px",
                  }}
                  to={"/customer/" + data.customer_id}
                >
                  {data.name}
                </Link>
              </p>
              <p
                className=""
                style={{
                  fontSize: "14px",
                  margin: "4px",
                }}
              >
                Манзили: {data.where}
              </p>
              {/* <p
                  className=""
                  style={{
                    fontSize: "14px",
                    margin: "4px",
                  }}
                >
                  Санаси: {moment(data.date).format("DD.MM.YYYY")}
                </p> */}
              <p
                className=""
                style={{
                  fontSize: "14px",
                  margin: "4px",
                }}
              >
                Ишончнома №{" "}
              </p>
            </section>

            <table
              style={{
                borderCollapse: "collapse",
                width: "100%",
              }}
              border="1"
              className="text-[14px]"
              cellpadding="10"
            >
              <tr>
                <th
                  className="text-[14px] text-left text-bold border border-gray-400 px-4 py-2 border border-gray-400 px-4 py-2"
                  style={{
                    fontSize: "14px",
                    margin: 0,
                  }}
                >
                  №
                </th>
                <th
                  style={{
                    fontSize: "14px",
                    margin: 0,
                  }}
                  className="text-[14px] text-left text-bold border border-gray-400 px-4 py-2"
                >
                  Юк номи
                </th>
                <th
                  style={{
                    fontSize: "14px",
                    margin: 0,
                  }}
                  className="text-[14px] text-left text-bold border border-gray-400 px-4 py-2"
                >
                  Ўлчов бирлиги
                </th>
                <th
                  style={{
                    fontSize: "14px",
                    margin: 0,
                  }}
                  className="text-[14px] text-left text-bold border border-gray-400 px-4 py-2"
                >
                  Тара
                </th>
                <th
                  style={{
                    fontSize: "14px",
                    margin: 0,
                  }}
                  className="text-[14px] text-left text-bold border border-gray-400 px-4 py-2"
                >
                  {" "}
                  Умумий огирлик
                </th>
                <th
                  style={{
                    fontSize: "14px",
                    margin: 0,
                  }}
                  className="text-[14px] text-left text-bold border border-gray-400 px-4 py-2"
                >
                  Соф огирлик
                </th>
              </tr>
              {data?.products?.map((el, i) => {
                return (
                  <tr
                    style={{
                      fontSize: "14px",
                      margin: 0,
                    }}
                  >
                    <td
                      style={{
                        fontSize: "14px",
                        margin: 0,
                        padding: "4px",
                      }}
                      className="text-[14px] text-left text-bold border border-gray-400 px-4 py-1"
                    >
                      {i + 1}
                    </td>
                    <td
                      style={{
                        fontSize: "14px",
                        margin: 0,
                        padding: 0,
                        paddingLeft: "4px",
                        lineHeight: "14px",
                        padding: "4px",
                      }}
                      className="text-[14px] text-left text-bold border border-gray-400 px-4 py-1"
                    >
                      {el.name}
                    </td>
                    <td
                      style={{
                        fontSize: "14px",
                        margin: 0,
                        padding: 0,
                        paddingLeft: "4px",
                        lineHeight: "14px",
                        padding: "4px",
                      }}
                      className="text-[14px] text-left text-bold border border-gray-400 px-4 py-1"
                    >
                      Tn
                    </td>
                    <td
                      style={{
                        fontSize: "14px",
                        margin: 0,
                        padding: "4px",
                      }}
                      className="text-[14px] text-left text-bold border border-gray-400 px-4 py-1"
                    ></td>
                    <td
                      style={{
                        fontSize: "14px",
                        margin: 0,
                        padding: "4px",
                      }}
                      className="text-[14px] text-left text-bold border border-gray-400 px-4 py-1"
                    ></td>
                    <td
                      style={{
                        fontSize: "14px",
                        margin: 0,
                        padding: 0,
                        paddingLeft: "4px",
                        lineHeight: "14px",
                        padding: "4px",
                      }}
                      className="text-[14px] text-left text-bold border border-gray-400 px-4 py-1"
                    >
                      {el.tonna}
                    </td>
                  </tr>
                );
              })}
            </table>

            <footer>
              <div
                className="flex items-center justify-between w-[100%]"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <p className="text-[12px] m-0 p-[3px]">
                  Жами миқдори: {numberToWords(sum * 1000)} Kg
                </p>
                <p className="text-[12px] m-0 p-[3px]">
                  {(sum * 1000) / 50} дона Qop
                </p>
              </div>
              <div
                className="flex items-center justify-between w-[100%]"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <p
                  className="text-[12px] "
                  style={{
                    fontSize: "12px",
                    padding: 0,
                    margin: 0,
                  }}
                >
                  Phone: +998 93 894 40 00
                </p>
                <p
                  className="text-[12px] p-0 m-0  w-[50%]"
                  style={{
                    width: "50%",
                    fontSize: "12px",
                    padding: 0,
                    margin: 0,
                  }}
                >
                  Махсулотни ишлаб чиқарувчи томонидан махсус қопларда
                  қадоқанланган холда, сон ва сифати жиҳатдан бутлиги ва
                  тўлиқлигини назоратини қилган тартибда кабул килдим.
                </p>
              </div>
              <div
                className="flex items-center justify-between mt-2"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  marginTop: "4px",
                }}
              >
                <p
                  className="text-[14px] m-0 p-[3px]"
                  style={{
                    fontSize: "12px",
                    padding: 0,
                    margin: 0,
                  }}
                >
                  ______________А.Abduvaliev
                </p>
                <p
                  className="text-[14px] m-0 p-[3px]"
                  style={{
                    fontSize: "12px",
                    padding: 0,
                    margin: 0,
                    marginTop: "8px",
                  }}
                >
                  ______________А.Parpiyev
                </p>
              </div>
            </footer>
          </div>
        </div>
      </div>
    </div>
  );
}
